import type { FaireProductEntity } from "../../entity_types/product";

export const p_v6jcf3n4ry: FaireProductEntity = {
  token: "p_v6jcf3n4ry",
  type: "product",
  name: "Strawberry Little Notes® Duo Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e37664f69af5d1fbc1da47bc94d0b8dd2f13fd0ef3454e88fd1fca9d47aae86d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/451dc31843c35a7b22d0f1b9776c90f85a2a507367e71bcac81a418b0bd514d3.jpeg",
    "https://cdn.faire.com/fastly/e0a9d9ee863a135d7229b741b06bb43b83152c58d34795272a65cc346c113b86.jpeg",
    "https://cdn.faire.com/fastly/8b2e600f8c15b0a1f2a1f980609c611d5136bf0efc04ef74130ea79a47f72843.jpeg",
    "https://cdn.faire.com/fastly/ef867dcad6543a016b7b8ee7c742e3d06329487b34bf59a4cd23bf09c77caac7.jpeg",
  ],
  priceDollars: 6,
  description:
    "The cutest little duos you ever did see. Set of 10 Little Notes®and 10 Little Note Envelopes. These corresponding Little Notes® and printed envelopes take the surprise and delight of Little Notes to the next level - so up your gift tag/secret note/barista tip game! Please note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:45.195Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
